$(document).ready(function() {
  var vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", vh + "px");

  window.addEventListener("resize", function () {
    var vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", vh + "px");
  });

  $(window).on('scroll',function () {
    if($(this).scrollTop() > 50) {
        $('.page-header').addClass('page-header--scrolled');
        $('.main').addClass('scrolled');
    } else {
        $('.page-header').removeClass('page-header--scrolled');
        $('.main').removeClass('scrolled');
    }
  });

  // Control main form chars length
  $('.form .textarea textarea').on('keyup', function() {
    $('.form .textarea #char-count').text( $(this).val().length );
  });

  // Videos
  $('.start-btn').on('click', function() {
    var src = $(this).parent().data('src');
    $(this).hide();
    $(this).parent().find('.iframe-wrapper').show();
    var iframe = $(this).parent().find('iframe');
    setTimeout(function() {
      iframe.attr('src', src);
    }, 100);
  });

  $('.action__btn').on('click', function() {
    var counter = $(this).data('counter');
    $('.action .item-'+counter+' .start-btn').click();
  });

  // FAQ
  $('.faq__question').on('click', function() {
    $(this).toggleClass('opened');
    $(this).next('.faq__answer').slideToggle('slow');
  });

  $('.footer__up').on('click', function() {
    $("html, body").animate({scrollTop: 0}, 1000);
  });

  $('#mobileBurger').on('click', function() {
    $(this).toggleClass('open');
    $('.site-navigation').toggleClass('site-navigation--active');
    $('.page-header').toggleClass('page-header--active');
  });

  //Smooth scrolling with links
  $('a[href*=\\#]').on('click', function(event){     
    event.preventDefault();
    if ( $('#mobileBurger').hasClass('open') ) {
      $('#mobileBurger').removeClass('open');
      $('.site-navigation').removeClass('site-navigation--active');
      $('.page-header').removeClass('page-header--active');
    }
    $('html,body').animate({scrollTop: $(this.hash).offset().top - 85}, 1000);
  });

  // Form 1 & 2 step
  $('.property-type .wpcf7-list-item label, .your-accident .wpcf7-list-item label').on('click', function() {
    $('.property-type .wpcf7-list-item label').removeClass('selected');
    $('.your-accident .wpcf7-list-item label').removeClass('selected');
    $(this).addClass('selected');
  })

  // Popup on mail sent successfully
  document.addEventListener( 'wpcf7mailsent', function( event ) {
    $('.mail-sent').fadeIn('slow');
  }, false );

  $('.mail-sent').on('click', function(e) {
    if ( $(e.target).closest('.mail-sent__link').length != 0 ) return true;
    if ( $(e.target).closest('.mail-sent__wrapper').length != 0 ) return false;
    $(this).fadeOut('slow');
  });

  $('.mail-sent__close').on('click', function() {
    $('.mail-sent').fadeOut('slow');
  });
  
});
